/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
    EfsMelcoModelsUserAlphabet,
    EfsMelcoModelsUserAlphabetFromJSON,
    EfsMelcoModelsUserAlphabetFromJSONTyped,
    EfsMelcoModelsUserAlphabetToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoModelsUserAlphabet
 */
export interface EfsMelcoModelsGenericList1MelcoModelsUserAlphabet {
    /**
     * 
     * @type {Array<EfsMelcoModelsUserAlphabet>}
     * @memberof EfsMelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    list: Array<EfsMelcoModelsUserAlphabet>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSON(json: any): EfsMelcoModelsGenericList1MelcoModelsUserAlphabet {
    return EfsMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoModelsUserAlphabet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoModelsUserAlphabetFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoModelsUserAlphabetToJSON(value?: EfsMelcoModelsGenericList1MelcoModelsUserAlphabet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoModelsUserAlphabetToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


